"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const luxon_1 = require("luxon");
exports.timeZoneMap = {
    '-12:00': '(GMT -12:00) Eniwetok, Kwajalein',
    '-11:00': '(GMT -11:00) Midway Island, Samoa',
    '-10:00': '(GMT -10:00) Hawaii',
    '-09:00': '(GMT -9:00) Alaska',
    '-08:00': '(GMT -8:00) Pacific Time (US & Canada)',
    '-07:00': '(GMT -7:00) Mountain Time (US & Canada)',
    '-06:00': '(GMT -6:00) Central Time (US & Canada), Mexico City',
    '-05:00': '(GMT -5:00) Eastern Time (US & Canada), Bogota, Lima',
    '-04:00': '(GMT -4:00) Atlantic Time (US & Canada), Caracas, La Paz',
    '-03:30': '(GMT -3:30) Newfoundland',
    '-03:00': '(GMT -3:00) Brazil, Buenos Aires, Georgetown',
    '-02:00': '(GMT -2:00) Mid-Atlantic',
    '-01:00': '(GMT -1:00) Azores, Cape Verde Islands',
    '+00:00': '(GMT) Western Europe Time, London, Lisbon, Casablanca',
    '-00:00': '(GMT) Western Europe Time, London, Lisbon, Casablanca',
    '+01:00': '(GMT +1:00) Brussels, Copenhagen, Madrid, Paris',
    '+02:00': '(GMT +2:00) Kaliningrad, South Africa',
    '+03:00': '(GMT +3:00) Baghdad, Riyadh, Moscow, St. Petersburg',
    '+03:30': '(GMT +3:30) Tehran',
    '+04:00': '(GMT +4:00) Abu Dhabi, Muscat, Baku, Tbilisi',
    '+04:30': '(GMT +4:30) Kabul',
    '+05:00': '(GMT +5:00) Ekaterinburg, Islamabad, Karachi, Tashkent',
    '+05:30': '(GMT +5:30) Bombay, Calcutta, Madras, New Delhi',
    '+05:45': '(GMT +5:45) Kathmandu',
    '+06:00': '(GMT +6:00) Almaty, Dhaka, Colombo',
    '+07:00': '(GMT +7:00) Bangkok, Hanoi, Jakarta',
    '+08:00': '(GMT +8:00) Beijing, Perth, Singapore, Hong Kong',
    '+09:00': '(GMT +9:00) Tokyo, Seoul, Osaka, Sapporo, Yakutsk',
    '+09:30': '(GMT +9:30) Adelaide, Darwin',
    '+10:00': '(GMT +10:00) Eastern Australia, Guam, Vladivostok',
    '+11:00': '(GMT +11:00) Magadan, Solomon Islands, New Caledonia',
    '+12:00': '(GMT +12:00) Auckland, Wellington, Fiji, Kamchatka',
};
exports.formatDate = (date) => {
    if (date == null) {
        return null;
    }
    const year = date.substr(0, 4);
    const month = date.substr(5, 2);
    const day = date.substr(8, 2);
    return new Date(`${month}/${day}/${year}`);
};
exports.updateTimeZoneOfDateTime = (currValue, zoneName) => {
    const key = Object.keys(exports.timeZoneMap).find(k => exports.timeZoneMap[k] === zoneName);
    return currValue.substring(0, currValue.length - 6) + key;
};
exports.getSecondsFromDate = (date) => {
    const { hour, minute, second } = luxon_1.DateTime.fromISO(date, { setZone: true });
    return hour * 60 * 60 + minute * 60 + second;
};
exports.updateTimeOfDateTime = (currValue, totalSeconds) => {
    const hour = Math.floor(totalSeconds / 3600);
    const minute = Math.floor((totalSeconds % 3600) / 60);
    const second = Math.floor((totalSeconds % 3600) % 60);
    return luxon_1.DateTime.fromISO(currValue, { setZone: true })
        .set({
        hour,
        minute,
        second,
    })
        .toISO();
};
exports.updateDateOfDateTime = (currValue, date) => {
    const dateTime = luxon_1.DateTime.fromJSDate(date);
    const { year, month, day } = dateTime;
    return luxon_1.DateTime.fromISO(currValue, { setZone: true })
        .set({
        year,
        month,
        day,
    })
        .toISO();
};
exports.getDisplayDate = (date) => luxon_1.DateTime.fromISO(date, { setZone: true }).toLocaleString(luxon_1.DateTime.DATE_MED);
exports.getDisplayTime = (date) => luxon_1.DateTime.fromISO(date, { setZone: true }).toLocaleString(luxon_1.DateTime.TIME_SIMPLE);
exports.getDisplayTimeZone = (date) => exports.timeZoneMap[date.substr(-6)] || 'Unknown';
exports.floatToStringArr = (floatArr) => floatArr.map(floatVal => floatVal.toString());
exports.stringToFloatArr = (stringArr) => stringArr.map(stringVal => stringVal != null && stringVal.length !== 0 && !isNaN(stringVal) ? parseFloat(stringVal) : undefined);
exports.getOperatorByValueType = (values) => {
    if (typeof values[0] === 'string') {
        return 'stringValues';
    }
    if (typeof values[0] === 'number') {
        return 'numberValues';
    }
};
exports.getKeyPathAttributeType = (keyPathSelected, schemas) => schemas.find(attributes => attributes.keyPath === keyPathSelected).attributeType;
exports.attributeTypeToComparisonPredicateValue = (keyPathSelected, schemas) => {
    const mapping = {
        ARRAY_OF_STRINGS: 'stringValues',
        ARRAY_OF_BOOLEANS: 'booleanValues',
        ARRAY_OF_NUMBERS: 'numberValues',
        ARRAY_OF_DATE_TIMES: 'dateTimeValues',
        STRING: 'stringValue',
        BOOLEAN: 'booleanValue',
        NUMBER: 'numberValue',
        DATE_TIME: 'dateTimeValue',
    };
    return mapping[exports.getKeyPathAttributeType(keyPathSelected, schemas)];
};
const comparisonToDisplay = {
    BEGINS_WITH: 'begins with',
    ENDS_WITH: 'ends with',
    LIKE: 'matches',
    CONTAINS: 'contains',
    EQUAL_TO: 'equals',
    NOT_EQUAL_TO: 'does not equal',
    LESS_THAN: 'is less than',
    LESS_THAN_OR_EQUAL_TO: 'is less than or equal',
    GREATER_THAN: 'is greater than',
    GREATER_THAN_OR_EQUAL_TO: 'is greater than or equal',
    IN: 'is one of',
    BETWEEN: 'is between',
    GEO_WITHIN: 'is within',
    IN_LIST: 'is in list',
};
exports.sanitizeValue = (val) => (Object.assign({ numberValue: null, numberValues: null, stringValue: null, stringValues: null, booleanValue: null, booleanValues: null, dateTimeValue: null, dateTimeValues: null, listValue: null }, val));
exports.getComparisonOperatorDisplayValue = (comparisonOperator) => comparisonToDisplay[comparisonOperator];
exports.getInitialValue = (valueOperator) => {
    if (valueOperator.includes('booleanValue')) {
        return true;
    }
    if (valueOperator.includes('dateTimeValue')) {
        return luxon_1.DateTime.local().set({ second: 0, millisecond: 0 }).toISO();
    }
    if (valueOperator.includes('orderedDateListValue')) {
        return [
            luxon_1.DateTime.local().set({ second: 0, millisecond: 0 }).toISO(),
            luxon_1.DateTime.local().plus({ hours: 1 }).set({ second: 0, millisecond: 0 }).toISO(),
        ];
    }
    return undefined;
};
exports.getInitialOperatorComponent = (comparisonOperator, keyPathSelected, schemas, listEnabledKeyPaths, modifier = 'ANY') => exports.getOperators(keyPathSelected, schemas, listEnabledKeyPaths, modifier).find(op => op.comparisonOperator === comparisonOperator);
exports.getOperators = (keyPathSelected, schemas, listEnabledKeyPaths, modifier = 'ANY') => {
    const { attributeType } = schemas.find(attributes => attributes.keyPath === keyPathSelected);
    if (attributeType === 'STRING') {
        let components = [
            {
                comparisonOperator: 'EQUAL_TO',
                valueOperator: 'stringValue',
                modifier: 'DIRECT',
            },
            {
                comparisonOperator: 'NOT_EQUAL_TO',
                valueOperator: 'stringValue',
                modifier: 'DIRECT',
            },
            {
                comparisonOperator: 'LIKE',
                valueOperator: 'stringValue',
                modifier: 'DIRECT',
            },
            {
                comparisonOperator: 'BEGINS_WITH',
                valueOperator: 'stringValue',
                modifier: 'DIRECT',
            },
            {
                comparisonOperator: 'ENDS_WITH',
                valueOperator: 'stringValue',
                modifier: 'DIRECT',
            },
            {
                comparisonOperator: 'IN',
                valueOperator: 'unOrderedListValue',
                modifier: 'DIRECT',
            },
            {
                comparisonOperator: 'CONTAINS',
                valueOperator: 'stringValue',
                modifier: 'DIRECT',
            },
        ];
        if (listEnabledKeyPaths && listEnabledKeyPaths.includes(keyPathSelected)) {
            components.push({
                comparisonOperator: 'IN_LIST',
                valueOperator: 'stringValue',
                modifier: 'DIRECT',
            });
        }
        return components;
    }
    if (attributeType === 'ARRAY_OF_STRINGS') {
        if (modifier === 'ALL' || modifier === 'ANY') {
            return [
                {
                    comparisonOperator: 'EQUAL_TO',
                    valueOperator: 'stringValue',
                    modifier,
                },
                {
                    comparisonOperator: 'NOT_EQUAL_TO',
                    valueOperator: 'stringValue',
                    modifier,
                },
                {
                    comparisonOperator: 'LIKE',
                    valueOperator: 'stringValue',
                    modifier,
                },
                {
                    comparisonOperator: 'BEGINS_WITH',
                    valueOperator: 'stringValue',
                    modifier,
                },
                {
                    comparisonOperator: 'ENDS_WITH',
                    valueOperator: 'stringValue',
                    modifier,
                },
                {
                    comparisonOperator: 'IN',
                    valueOperator: 'unOrderedListValue',
                    modifier,
                },
                {
                    comparisonOperator: 'CONTAINS',
                    valueOperator: 'stringValue',
                    modifier,
                },
            ];
        }
        if (modifier === 'DIRECT') {
            return [
                {
                    comparisonOperator: 'EQUAL_TO',
                    valueOperator: 'orderedListValue',
                    modifier,
                },
                {
                    comparisonOperator: 'NOT_EQUAL_TO',
                    valueOperator: 'orderedListValue',
                    modifier,
                },
                {
                    comparisonOperator: 'CONTAINS',
                    valueOperator: 'stringValue',
                    modifier,
                },
            ];
        }
    }
    if (attributeType === 'NUMBER') {
        return [
            {
                comparisonOperator: 'EQUAL_TO',
                valueOperator: 'numberValue',
                modifier: 'DIRECT',
            },
            {
                comparisonOperator: 'NOT_EQUAL_TO',
                valueOperator: 'numberValue',
                modifier: 'DIRECT',
            },
            {
                comparisonOperator: 'LESS_THAN',
                valueOperator: 'numberValue',
                modifier: 'DIRECT',
            },
            {
                comparisonOperator: 'LESS_THAN_OR_EQUAL_TO',
                valueOperator: 'numberValue',
                modifier: 'DIRECT',
            },
            {
                comparisonOperator: 'GREATER_THAN',
                valueOperator: 'numberValue',
                modifier: 'DIRECT',
            },
            {
                comparisonOperator: 'GREATER_THAN_OR_EQUAL_TO',
                valueOperator: 'numberValue',
                modifier: 'DIRECT',
            },
            {
                comparisonOperator: 'IN',
                valueOperator: 'unOrderedListValue',
                modifier: 'DIRECT',
            },
            {
                comparisonOperator: 'BETWEEN',
                valueOperator: 'rangeValue',
                modifier: 'DIRECT',
            },
        ];
    }
    if (attributeType === 'ARRAY_OF_NUMBERS') {
        if (modifier === 'ALL' || modifier === 'ANY') {
            return [
                {
                    comparisonOperator: 'EQUAL_TO',
                    valueOperator: 'numberValue',
                    modifier,
                },
                {
                    comparisonOperator: 'NOT_EQUAL_TO',
                    valueOperator: 'numberValue',
                    modifier,
                },
                {
                    comparisonOperator: 'LESS_THAN',
                    valueOperator: 'numberValue',
                    modifier,
                },
                {
                    comparisonOperator: 'LESS_THAN_OR_EQUAL_TO',
                    valueOperator: 'numberValue',
                    modifier,
                },
                {
                    comparisonOperator: 'GREATER_THAN',
                    valueOperator: 'numberValue',
                    modifier,
                },
                {
                    comparisonOperator: 'GREATER_THAN_OR_EQUAL_TO',
                    valueOperator: 'numberValue',
                    modifier,
                },
                {
                    comparisonOperator: 'IN',
                    valueOperator: 'unOrderedListValue',
                    modifier,
                },
                {
                    comparisonOperator: 'BETWEEN',
                    valueOperator: 'rangeValue',
                    modifier,
                },
            ];
        }
        if (modifier === 'DIRECT') {
            return [
                {
                    comparisonOperator: 'EQUAL_TO',
                    valueOperator: 'orderedListValue',
                    modifier,
                },
                {
                    comparisonOperator: 'NOT_EQUAL_TO',
                    valueOperator: 'orderedListValue',
                    modifier,
                },
                {
                    comparisonOperator: 'CONTAINS',
                    valueOperator: 'numberValue',
                    modifier,
                },
                {
                    comparisonOperator: 'GEO_WITHIN',
                    valueOperator: 'numberValues',
                    modifier,
                },
            ];
        }
    }
    if (attributeType === 'BOOLEAN') {
        return [
            {
                comparisonOperator: 'EQUAL_TO',
                valueOperator: 'booleanValue',
                modifier: 'DIRECT',
            },
        ];
    }
    if (attributeType === 'ARRAY_OF_BOOLEANS') {
        return [
            {
                comparisonOperator: 'EQUAL_TO',
                valueOperator: 'booleanValue',
                modifier,
            },
        ];
    }
    if (attributeType === 'DATE_TIME') {
        return [
            {
                comparisonOperator: 'EQUAL_TO',
                valueOperator: 'dateTimeValue',
                modifier: 'DIRECT',
            },
            {
                comparisonOperator: 'NOT_EQUAL_TO',
                valueOperator: 'dateTimeValue',
                modifier: 'DIRECT',
            },
            {
                comparisonOperator: 'LESS_THAN',
                valueOperator: 'dateTimeValue',
                modifier: 'DIRECT',
            },
            {
                comparisonOperator: 'LESS_THAN_OR_EQUAL_TO',
                valueOperator: 'dateTimeValue',
                modifier: 'DIRECT',
            },
            {
                comparisonOperator: 'GREATER_THAN',
                valueOperator: 'dateTimeValue',
                modifier: 'DIRECT',
            },
            {
                comparisonOperator: 'GREATER_THAN_OR_EQUAL_TO',
                valueOperator: 'dateTimeValue',
                modifier: 'DIRECT',
            },
            {
                comparisonOperator: 'IN',
                valueOperator: 'unOrderedDateListValue',
                modifier: 'DIRECT',
            },
            {
                comparisonOperator: 'BETWEEN',
                valueOperator: 'rangeDateValue',
                modifier: 'DIRECT',
            },
        ];
    }
    if (attributeType === 'ARRAY_OF_DATE_TIMES') {
        if (modifier === 'ALL' || modifier === 'ANY') {
            return [
                {
                    comparisonOperator: 'EQUAL_TO',
                    valueOperator: 'dateTimeValue',
                    modifier,
                },
                {
                    comparisonOperator: 'NOT_EQUAL_TO',
                    valueOperator: 'dateTimeValue',
                    modifier,
                },
                {
                    comparisonOperator: 'LESS_THAN',
                    valueOperator: 'dateTimeValue',
                    modifier,
                },
                {
                    comparisonOperator: 'LESS_THAN_OR_EQUAL_TO',
                    valueOperator: 'dateTimeValue',
                    modifier,
                },
                {
                    comparisonOperator: 'GREATER_THAN',
                    valueOperator: 'dateTimeValue',
                    modifier,
                },
                {
                    comparisonOperator: 'GREATER_THAN_OR_EQUAL_TO',
                    valueOperator: 'dateTimeValue',
                    modifier,
                },
                {
                    comparisonOperator: 'IN',
                    valueOperator: 'unOrderedDateListValue',
                    modifier,
                },
                {
                    comparisonOperator: 'BETWEEN',
                    valueOperator: 'rangeDateValue',
                    modifier,
                },
            ];
        }
        if (modifier === 'DIRECT') {
            return [
                {
                    comparisonOperator: 'EQUAL_TO',
                    valueOperator: 'orderedDateListValue',
                    modifier,
                },
                {
                    comparisonOperator: 'NOT_EQUAL_TO',
                    valueOperator: 'orderedDateListValue',
                    modifier,
                },
                {
                    comparisonOperator: 'CONTAINS',
                    valueOperator: 'dateTimeValue',
                    modifier,
                },
            ];
        }
    }
};
